import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const AppViews = () => {
    return (
        <Suspense fallback={<Loading cover="content" />}>
            <Switch>
                <Route path={`${APP_PREFIX_PATH}/dashboard`} component={lazy(() => import(`./dashboard`))} />
                <Route path={`${APP_PREFIX_PATH}/invoices`} component={lazy(() => import(`./invoices`))} />
                <Route path={`${APP_PREFIX_PATH}/received-invoice`} component={lazy(() => import(`./received-invoice/index`))} />
                <Route path={`${APP_PREFIX_PATH}/settings`} component={lazy(() => import(`./setting`))} />
                <Route path={`${APP_PREFIX_PATH}/supports`} component={lazy(() => import(`./support`))} />
                <Route path={`${APP_PREFIX_PATH}/terminals`} component={lazy(() => import(`./terminal`))} />
                <Route path={`${APP_PREFIX_PATH}/shops`} component={lazy(() => import(`./shop`))} />
                <Route path={`${APP_PREFIX_PATH}/salesmen`} component={lazy(() => import(`./salesman`))} />
                <Route path={`${APP_PREFIX_PATH}/vouchers`} component={lazy(() => import(`./voucher`))} />
                <Route path={`${APP_PREFIX_PATH}/voucher-batches`} component={lazy(() => import(`./voucher-batch`))} />
                <Route path={`${APP_PREFIX_PATH}/managers`} component={lazy(() => import(`./manager`))} />
                <Route path={`${APP_PREFIX_PATH}/transactions`} component={lazy(() => import(`./transaction`))} />
                <Route path={`${APP_PREFIX_PATH}/audit-logs`} component={lazy(() => import(`./audit-log`))} />
                <Route path={`${APP_PREFIX_PATH}/profile`} component={lazy(() => import(`./profile`))} />
                <Route path={`${APP_PREFIX_PATH}/bulks`} component={lazy(() => import(`./bulks`))} />
                <Route path={`${APP_PREFIX_PATH}/collect`} component={lazy(() => import(`./collecting`))} />
                <Route path={`${APP_PREFIX_PATH}/account`} component={lazy(() => import(`./account`))} />
                <Route path={`${APP_PREFIX_PATH}/expense`} component={lazy(() => import(`./expense`))} />
                <Route path={`${APP_PREFIX_PATH}/income`} component={lazy(() => import(`./income`))} />
                <Route path={`${APP_PREFIX_PATH}/payment-method`} component={lazy(() => import(`./payment-method`))} />
                <Route path={`${APP_PREFIX_PATH}/credit-request`} component={lazy(() => import(`./credit-request`))} />
                <Route path={`${APP_PREFIX_PATH}/notifications`} component={lazy(() => import(`./notification-management`))} />
                <Route path={`${APP_PREFIX_PATH}/tej-declaration`} component={lazy(() => import(`./tej-declaration`))} />
                <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/dashboard`} />
            </Switch>
        </Suspense>
    )
}

export default React.memo(AppViews);